import React, { useState } from "react";
import { Box, Typography, Stack, Collapse, IconButton } from "@mui/material";
import { CodeRounded as CodeIcon } from "@mui/icons-material";

export default function Pm2AppCard({ app }) {
  const [logsOpen, setLogsOpen] = useState(false);
  const [logType, setLogType] = useState("out");

  return (
    <Box
      sx={{
        bgcolor: "rgba(0,0,0,0.2)",
        border: "1px solid rgba(234,240,248,0.05)",
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1.8,
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              bgcolor: app.status === "online" ? "#3ddc97" : "#ff6b81",
              boxShadow:
                app.status === "online"
                  ? "0 0 10px rgba(16,185,129,0.5)"
                  : "none",
            }}
          />
          <Typography
            variant="subtitle2"
            fontWeight="800"
            fontFamily="monospace"
            sx={{ fontSize: "0.85rem" }}
          >
            {app.name}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: "bold" }}
          >
            % {app.cpu || 0}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: "bold" }}
          >
            {app.memory || 0} MB
          </Typography>
          <IconButton
            size="small"
            onClick={() => setLogsOpen(!logsOpen)}
            sx={{
              color: logsOpen ? "primary.main" : "text.secondary",
              bgcolor: logsOpen ? "rgba(29,111,242,0.1)" : "transparent",
            }}
          >
            <CodeIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Box>

      <Collapse in={logsOpen} timeout="auto" unmountOnExit>
        <Box
          sx={{
            bgcolor: "#030305",
            borderTop: "1px solid rgba(234,240,248,0.05)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 1,
              bgcolor: "rgba(234,240,248,0.03)",
            }}
          >
            <Stack direction="row" spacing={1}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "#FF5F56",
                }}
              />
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "#FFBD2E",
                }}
              />
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "#27C93F",
                }}
              />
            </Stack>
            <Stack direction="row" spacing={2}>
              <Typography
                variant="caption"
                onClick={() => setLogType("out")}
                sx={{
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: logType === "out" ? "success.main" : "text.secondary",
                  textDecoration: logType === "out" ? "underline" : "none",
                }}
              >
                out.log
              </Typography>
              <Typography
                variant="caption"
                onClick={() => setLogType("err")}
                sx={{
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: logType === "err" ? "error.main" : "text.secondary",
                  textDecoration: logType === "err" ? "underline" : "none",
                }}
              >
                err.log
              </Typography>
            </Stack>
          </Box>
          <Box
            sx={{
              p: 2,
              maxHeight: 200,
              overflowY: "auto",
              fontFamily: "'Fira Code', monospace",
              fontSize: "0.75rem",
            }}
          >
            <Typography
              variant="inherit"
              sx={{
                whiteSpace: "pre-wrap",
                color: logType === "out" ? "#F8FAFC" : "#ff6b81",
              }}
            >
              {logType === "out"
                ? app.out_log || "> No standard output"
                : app.err_log || "> No error logs"}
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}
